import { createContext, useContext } from 'react'
import { uz, type Catalog } from './uz'
import { ru } from './ru'
import { en } from './en'

export type Lang = 'uz' | 'ru' | 'en'

export const CATALOGS: Record<Lang, Catalog> = { uz, ru, en }

export const LANG_LABELS: Record<Lang, string> = {
  uz: "O'zbekcha",
  ru: 'Русский',
  en: 'English',
}

const LANG_KEY = 'grom_admin_lang'

export function loadLang(): Lang {
  try {
    const v = localStorage.getItem(LANG_KEY)
    if (v === 'uz' || v === 'ru' || v === 'en') return v
  } catch {
    /* localStorage yopiq */
  }
  return 'uz'
}

export function saveLang(lang: Lang): void {
  try {
    localStorage.setItem(LANG_KEY, lang)
  } catch {
    /* localStorage yopiq */
  }
  document.documentElement.lang = lang
}

interface I18nValue {
  lang: Lang
  t: Catalog
  setLang: (l: Lang) => void
}

export const I18nContext = createContext<I18nValue>({
  lang: 'uz',
  t: uz,
  setLang: () => {},
})

/**
 * Katalogni to'g'ridan-to'g'ri qaytaradi: `t.table.filters`.
 * Dot-path satr ("table.filters") ATAYLAB ishlatilmaydi — u tipdan tashqarida
 * qoladi va yo'q kalit ish vaqtida `undefined` bo'lib chiqadi.
 */
export function useT(): Catalog {
  return useContext(I18nContext).t
}

export function useI18n(): I18nValue {
  return useContext(I18nContext)
}

export type { Catalog }
